import { render, staticRenderFns } from "./discordTalkroom4.vue?vue&type=template&id=dd86aece&scoped=true"
import script from "./discordTalkroom4.vue?vue&type=script&lang=js"
export * from "./discordTalkroom4.vue?vue&type=script&lang=js"
import style0 from "./discordTalkroom4.vue?vue&type=style&index=0&id=dd86aece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd86aece",
  null
  
)

export default component.exports